import React from "react";
import { connect } from "react-redux";
import { PageWrapper } from "../../../shared/layout";
import { Tabs, BarLoader } from "../../../shared/widgets";
import { style1 as useStyles } from "../../../styles/makeStyles";
import { selectDateFilter } from "../../../redux/actions/dateFilterAction";
import IssueList from "./IssueList";

function BalanceSpent(props) {
  const { location } = props;
  const classes = useStyles();
  const [ticketValue, setTicketValue] = React.useState("issueTicket");
  const handleChange = (event, newValue) => {
    setTicketValue(newValue);
  };

  const busNumber = location?.state?.busNumber || "";
  return (
    <div className={classes.root}>
      <PageWrapper>
        <PageWrapper.Header heading={`${busNumber}`} showBackArrow hideS />
        <div>
          <PageWrapper.Header hideS>
            <div className="dataTables_length tabWrapper">
              <Tabs
                tabs={[{ key: "issueTicket", display: "Total Issue Ticket On card" }]}
                activeTab={ticketValue}
                onTabSelection={(key) => {
                  handleChange("true", key);
                }}
              />
            </div>
          </PageWrapper.Header>
        </div>
        <div>
          <BarLoader scope="header" />
          {ticketValue === "issueTicket" ? <IssueList componentType="ticket" /> : null}
        </div>
      </PageWrapper>
    </div>
  );
}

function mapStateToProps() {
  return {};
}

const mapDispatchToProps = (dispatch) => ({
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(BalanceSpent);
